// extracted by mini-css-extract-plugin
module.exports = {"education":"how-education-works_education__RgPVC","educationTitle":"how-education-works_educationTitle__f7yXr"};